
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {Media} from './media.model';

@Injectable()
export class MediaService {

  constructor(private http: HttpClient) {
  }

  getMedia (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/media/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postMedia (file: File) {
    const body = new FormData();
    body.append('file', file);

    return this.http.post(GlobalVariable.BASE_API_URL + '/medias', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/media/media.service.ts